import { render, staticRenderFns } from "./SolicitudForm.vue?vue&type=template&id=7cf36c84&scoped=true&"
import script from "./SolicitudForm.vue?vue&type=script&lang=ts&"
export * from "./SolicitudForm.vue?vue&type=script&lang=ts&"
import style0 from "./SolicitudForm.vue?vue&type=style&index=0&id=7cf36c84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf36c84",
  null
  
)

export default component.exports